(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/error-helpers.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/error-helpers.js');
"use strict";

const {
  ErrorCodes
} = svs.lbUtils;
const getTitleAndErrorMessageFromWagerResponse = errorCode => {
  switch (errorCode) {
    case ErrorCodes.BAD_DRAWSTATE:
      return {
        title: 'Stängt för spel',
        errorMessage: 'Spelomgången har startat och vi tar inte emot fler spel.'
      };
    case ErrorCodes.DRAW_NOT_OPENED:
      return {
        title: 'Stängt för spel',
        errorMessage: 'Spelomgången har inte öppnat för spel, vänligen försök igen senare.'
      };
    case ErrorCodes.REGBET_DISABLED:
      return {
        title: 'Stängt för spel',
        errorMessage: 'Just nu går det inte att lägga detta spel, vänligen försök senare.'
      };
    case ErrorCodes.CUST_MAX_DRAW_REGAMT:
    case ErrorCodes.CUST_MAX_DRAW_EGNARADER_REGAMT:
    case ErrorCodes.SYNDICATE_MAX_DRAW_REGAMT:
    case ErrorCodes.SYNDICATE_MAX_DRAW_EGNARADER_REGAMT:
    case ErrorCodes.RETAILER_MAX_DRAW_REGAMT:
    case ErrorCodes.RETAILER_MAX_DRAW_ANDELSSPEL_REGAMT:
    case ErrorCodes.CUST_MAX_BOARDS_IN_DRAW:
    case ErrorCodes.SYNDICATE_MAX_BOARDS_IN_DRAW:
      return {
        title: 'Du har överskridit en gräns',
        errorMessage: 'Högsta antalet rader på denna omgång har överskridits.'
      };
    case ErrorCodes.NOT_ENOUGH_MONEY:
      return {
        title: 'Något gick fel!',
        errorMessage: 'Du har inte tillräckligt med pengar på ditt spelkonto'
      };
    default:
      return {
        title: 'Något gick fel!',
        errorMessage: 'Något gick fel vid betalningen, försök igen om en liten stund.'
      };
  }
};
setGlobal('svs.components.tipsen.engine.errorHelpers', {
  getTitleAndErrorMessageFromWagerResponse
});

 })(window);